export function walkAncestors(
  initial: HTMLElement | null,
  predicate: (element: HTMLElement) => boolean | undefined,
  root: HTMLElement = document.body,
): HTMLElement | null {
  let element = initial;
  while (element) {
    if (predicate(element)) {
      return element;
    }
    if (element === root) {
      return null;
    }
    element = element.parentElement;
  }
  return null;
}

export function isScrollable(element: HTMLElement | null): boolean {
  if (!element) {
    return false;
  }

  const computedStyle = window.getComputedStyle(element);
  return (
    computedStyle.overflow === 'auto' ||
    computedStyle.overflow === 'scroll' ||
    computedStyle['overflow-y' as keyof CSSStyleDeclaration] === 'auto' ||
    computedStyle['overflow-y' as keyof CSSStyleDeclaration] === 'scroll'
  );
}

export function isOverflowingAxis(
  element: HTMLElement,
  axis: 'x' | 'y',
): boolean {
  return (
    (axis === 'x' && element.clientWidth < element.scrollWidth) ||
    (axis === 'y' && element.clientHeight < element.scrollHeight)
  );
}

export function isFixed(element: HTMLElement | null): boolean {
  if (!element) {
    return false;
  }

  const computedStyle = window.getComputedStyle(element);
  return computedStyle.position === 'fixed';
}
